import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f775fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-blue-primary rounded-md mb-2"
}
const _hoisted_2 = { class: "text-center p-3" }
const _hoisted_3 = { class: "text-center text-white text-sm" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Update profile image  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "ml-2 pt-2" }
const _hoisted_10 = { class: "text-white block font-bold" }
const _hoisted_11 = { class: "text-gray-text" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-white mb-5" }, "PUBLIC PROFILE DETAILS", -1))
const _hoisted_14 = { class: "md:flex mb-3 items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "first-name",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Company Name", -1))
const _hoisted_16 = { class: "flex-grow" }
const _hoisted_17 = { class: "md:flex mb-3 items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "first-name",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Website", -1))
const _hoisted_19 = { class: "md:flex mb-3 items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "first-name",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Short Bio", -1))
const _hoisted_21 = { class: "md:flex mb-5 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm w-36 my-2 md:my-0" }, null, -1))
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDisplayUploadUserImageLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-white inline-block mr-2"
                }),
                _hoisted_5
              ]),
              _createElementVNode("input", {
                style: {"display":"none"},
                ref: "fileInput",
                type: "file",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                accept: ".png, .jpg, .jpeg"
              }, null, 544),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateUserImage && _ctx.updateUserImage(...args))),
                  disabled: !_ctx.$refs.fileInput,
                  class: "mr-3 bg-success-check disabled:bg-gray-600 text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                }, "Confirm", 8, _hoisted_7),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertUserImage && _ctx.revertUserImage(...args))),
                  class: "hover:underline"
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "inline-block border-black-border relative border rounded-full w-24 bottom-0 h-24 left-0 bg-cover bg-center bg-black-body",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
      }, [
        _createElementVNode("button", {
          class: "bg-black-body p-2 rounded-lg absolute",
          style: {"bottom":"0px","left":"0"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayUploadUserImageLabel = !_ctx.isDisplayUploadUserImageLabel))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-camera",
            class: "text-gray-text text-xl"
          })
        ])
      ], 4),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentCompany), 1),
        _createElementVNode("span", _hoisted_11, "Username: " + _toDisplayString(_ctx.user.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "companyName",
            placeholder: "Company Name",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company) = $event)),
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputHasChanged(_ctx.company, _ctx.userData.company)))
          }, null, 544), [
            [_vModelText, _ctx.company]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "website",
            placeholder: "Website",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.websiteURL) = $event)),
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputHasChanged(_ctx.user.websiteURL, _ctx.userData.websiteUrl)))
          }, null, 544), [
            [_vModelText, _ctx.user.websiteURL]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("textarea", {
            rows: "5",
            class: "form-control text-white border-0",
            id: "description",
            placeholder: "Provide a brief description of your game developer company",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.introduction) = $event)),
            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.inputHasChanged(_ctx.user.introduction, _ctx.userData.introduction)))
          }, null, 544), [
            [_vModelText, _ctx.user.introduction]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-primary text-white",
            disabled: !_ctx.valueChanged,
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateUserProfile && _ctx.updateUserProfile(...args)))
          }, "Save Changes", 8, _hoisted_23)
        ])
      ])
    ])
  ]))
}